export default {
  simpleList() {
    return axios.get('/feed-import-mappings/simple-list')
  },
}
